(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kaelte-klar-storefront"] && !Shopify.designMode) return;
  try {
    
  function initializeOfferLanding() {
    const search = window.location.search || '';
    if (!/(?:[?&])kk-offer=1(?:&|$)/.test(search)) return;
    const discountMatch = search.match(/(?:[?&])kk-discount=(\d{1,3})(?:&|$)/);
    const discount = discountMatch ? Number(discountMatch[1]) : 0;
    document.querySelectorAll('.kk-storefront').forEach(function(storefront) {
      storefront.dataset.kkOfferMode = 'true';
      if (Number.isInteger(discount) && discount >= 1 && discount <= 100) storefront.dataset.kkOfferDiscount = String(discount);
      const banner = storefront.querySelector('[data-kk-offer-banner]');
      if (banner) {
        banner.hidden = false;
        const title = banner.querySelector('[data-kk-offer-title]');
        const badge = banner.querySelector('[data-kk-offer-badge]');
        if (Number.isInteger(discount) && discount >= 1 && discount <= 100) {
          if (title && banner.dataset.kkOfferTitleTemplate) title.textContent = banner.dataset.kkOfferTitleTemplate.replace('__PERCENT__', String(discount));
          if (badge && banner.dataset.kkOfferBadgeTemplate) badge.textContent = banner.dataset.kkOfferBadgeTemplate.replace('__PERCENT__', String(discount));
        }
        if (title) storefront.setAttribute('aria-labelledby', title.id);
      }
    });
  }
  initializeOfferLanding();
  document.addEventListener('DOMContentLoaded', initializeOfferLanding);
  document.addEventListener('click', function(event) {
    const previewTrigger = event.target.closest('[data-kk-preview-open]');
    if (previewTrigger) {
      const dialog = document.getElementById(previewTrigger.getAttribute('aria-controls'));
      if (!dialog) return;
      const frame = dialog.querySelector('iframe[data-src]');
      const body = dialog.querySelector('[data-kk-preview-body]');
      if (frame && frame.dataset.loaded !== 'true') {
        if (body) body.classList.add('is-loading');
        frame.addEventListener('load', function() {
          frame.dataset.loaded = 'true';
          if (body) body.classList.remove('is-loading');
        }, { once: true });
        if (!frame.getAttribute('src')) frame.setAttribute('src', frame.dataset.src);
      } else if (body) {
        body.classList.remove('is-loading');
      }
      dialog.showModal();
      return;
    }

    const previewClose = event.target.closest('[data-kk-preview-close]');
    if (previewClose) {
      const dialog = previewClose.closest('[data-kk-preview-dialog]');
      if (dialog) dialog.close();
      return;
    }

    if (event.target.matches('[data-kk-preview-dialog]')) event.target.close();

  });
  function closeAddonDialog(dialog) {
    if (!dialog) return;
    dialog._kkPendingForm = null;
    if (dialog.open) dialog.close();
    document.documentElement.classList.remove('kk-addon-modal-open');
  }
  function continueAddonPurchase(dialog, withoutExtras) {
    const form = dialog && dialog._kkPendingForm;
    if (!form) return;
    if (withoutExtras) {
      dialog.querySelectorAll('[data-kk-purchase-addons] input[data-kk-addon]').forEach(function(input) { input.checked = false; });
    }
    dialog._kkPendingForm = null;
    form.dataset.kkAddonConfirmed = 'true';
    closeAddonDialog(dialog);
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }
  function openAddonDialog(dialog, form) {
    const card = form.closest('.kk-price-card');
    const planTitle = card && card.querySelector('.kk-plan-heading h3');
    const scope = form.querySelector('.kk-plan-scope input:checked');
    const price = card && (card.querySelector('.kk-offer-price__discounted') || card.querySelector('[data-kk-plan-price]'));
    const planSummary = dialog.querySelector('[data-kk-addon-plan]');
    const planPrice = dialog.querySelector('[data-kk-addon-plan-price]');
    if (planSummary) planSummary.textContent = [planTitle && planTitle.textContent.trim(), scope && scope.value].filter(Boolean).join(' · ');
    if (planPrice) planPrice.textContent = price ? price.textContent.trim().replace(/\s+/g, ' ') : '';
    dialog._kkPendingForm = form;
    if (typeof dialog.showModal !== 'function') {
      continueAddonPurchase(dialog, false);
      return;
    }
    document.documentElement.classList.add('kk-addon-modal-open');
    dialog.showModal();
    const firstChoice = dialog.querySelector('[data-kk-addon]');
    if (firstChoice) firstChoice.focus({ preventScroll: true });
  }
  document.addEventListener('click', function(event) {
    const closeButton = event.target.closest('[data-kk-addon-close]');
    if (closeButton) {
      closeAddonDialog(closeButton.closest('[data-kk-addon-dialog]'));
      return;
    }
    const skipButton = event.target.closest('[data-kk-addon-skip]');
    if (skipButton) {
      continueAddonPurchase(skipButton.closest('[data-kk-addon-dialog]'), true);
      return;
    }
    const confirmButton = event.target.closest('[data-kk-addon-confirm]');
    if (confirmButton) {
      continueAddonPurchase(confirmButton.closest('[data-kk-addon-dialog]'), false);
      return;
    }
    if (event.target.matches('[data-kk-addon-dialog]')) closeAddonDialog(event.target);
  });
  document.querySelectorAll('[data-kk-addon-dialog]').forEach(function(dialog) {
    dialog.addEventListener('close', function() { dialog._kkPendingForm = null; document.documentElement.classList.remove('kk-addon-modal-open'); });
    dialog.addEventListener('cancel', function() { document.documentElement.classList.remove('kk-addon-modal-open'); });
  });
  function initializePurchaseForms() {
    document.querySelectorAll('.kk-product-form').forEach(function(form) {
      if (form.closest('.kk-pricing')?.dataset.kkSubmitting === 'true') return;
      const quantity = form.querySelector('input[name="quantity"]');
      if (quantity) { quantity.setAttribute('value', '1'); quantity.value = '1'; }
    });
    document.querySelectorAll('[data-kk-purchase-scope] input:checked').forEach(function(input) {
      if (input.closest('.kk-pricing')?.dataset.kkSubmitting === 'true') return;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  document.addEventListener('DOMContentLoaded', initializePurchaseForms);
  window.addEventListener('load', initializePurchaseForms);
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      document.querySelectorAll('.kk-pricing, .kk-product-form').forEach(function(element) { element.dataset.kkSubmitting = 'false'; });
      document.querySelectorAll('[data-kk-purchase-scope], .kk-plan-scope').forEach(function(fieldset) { fieldset.disabled = false; });
    }
    initializePurchaseForms();
  });

  document.querySelectorAll('[data-kk-purchase-scope]').forEach(function(selector) {
    selector.hidden = false;
    selector.closest('.kk-pricing').dataset.kkUnifiedScope = 'true';
  });
  document.addEventListener('change', function(event) {
    const choice = event.target.closest('[data-kk-purchase-scope] input');
    if (!choice || !choice.checked) return;
    const pricing = choice.closest('.kk-pricing');
    pricing.querySelectorAll('.kk-plan-scope input').forEach(function(input) {
      if (input.closest('[data-kk-fixed-scope]')) return;
      input.checked = input.value === choice.value;
      if (input.checked) input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  document.addEventListener('change', function(event) {
    const scopeInput = event.target.closest('.kk-plan-scope input[data-kk-price]');
    if (!scopeInput || !scopeInput.checked) return;
    const card = scopeInput.closest('.kk-price-card');
    const price = card && card.querySelector('[data-kk-plan-price]');
    if (!price) return;
    const storefront = card.closest('.kk-storefront');
    const discount = Number(storefront?.dataset.kkOfferDiscount || 0);
    const baseCents = Number(scopeInput.dataset.kkPriceCents || 0);
    const offerEligible = card?.dataset.kkOfferEligible === 'true';
    if (offerEligible && Number.isInteger(discount) && discount >= 1 && discount <= 100 && Number.isSafeInteger(baseCents) && baseCents >= 0) {
      const discountedCents = Math.round(baseCents * (100 - discount) / 100);
      const number = (discountedCents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const currency = (scopeInput.dataset.kkPrice.match(/[^\d\s.,]+/) || ['€'])[0];
      const discountedPrice = scopeInput.dataset.kkPrice.trim().startsWith(currency) ? currency + number : number + '\u00a0' + currency;
      const original = document.createElement('span');
      original.className = 'kk-offer-price__original';
      original.textContent = scopeInput.dataset.kkPrice;
      const discounted = document.createElement('span');
      discounted.className = 'kk-offer-price__discounted';
      discounted.textContent = discountedPrice;
      price.classList.add('kk-offer-price');
      price.replaceChildren(original, discounted);
      const pricing = card.closest('.kk-pricing');
      if (pricing?.dataset.kkOfferPriceTemplate) price.setAttribute('aria-label', pricing.dataset.kkOfferPriceTemplate.replace('__ORIGINAL__', scopeInput.dataset.kkPrice).replace('__DISCOUNTED__', discountedPrice));
    } else if (scopeInput.dataset.kkComparePrice) {
      const original = document.createElement('span');
      original.className = 'kk-offer-price__original';
      original.setAttribute('aria-hidden', 'true');
      original.textContent = scopeInput.dataset.kkComparePrice;
      const discounted = document.createElement('span');
      discounted.className = 'kk-offer-price__discounted';
      discounted.setAttribute('aria-hidden', 'true');
      discounted.textContent = scopeInput.dataset.kkPrice;
      price.classList.add('kk-offer-price');
      price.replaceChildren(original, discounted);
      const pricing = card.closest('.kk-pricing');
      if (pricing?.dataset.kkOfferPriceTemplate) price.setAttribute('aria-label', pricing.dataset.kkOfferPriceTemplate.replace('__ORIGINAL__', scopeInput.dataset.kkComparePrice).replace('__DISCOUNTED__', scopeInput.dataset.kkPrice));
    } else {
      price.classList?.remove('kk-offer-price');
      price.removeAttribute('aria-label');
      price.textContent = scopeInput.dataset.kkPrice;
    }
    const summary = card.querySelector('[data-kk-scope-summary]');
    if (summary) summary.textContent = scopeInput.dataset.kkSummary;
    const selectedArea = card.querySelector('[data-kk-selected-area]');
    if (selectedArea) selectedArea.textContent = scopeInput.value;
    const variantInput = card.querySelector('input[name="id"][data-kk-variant-both]');
    if (variantInput) {
      const scopeKey = scopeInput.value === 'GP1 + GP2' ? 'both' : scopeInput.value.toLowerCase();
      const nextVariantId = variantInput.dataset['kkVariant' + scopeKey.charAt(0).toUpperCase() + scopeKey.slice(1)];
      const available = variantInput.dataset['kkAvailable' + scopeKey.charAt(0).toUpperCase() + scopeKey.slice(1)] === 'true';
      const purchaseButton = card.querySelector('button[type="submit"]');
      if (purchaseButton) { purchaseButton.disabled = !available || !nextVariantId; purchaseButton.textContent = available && nextVariantId ? purchaseButton.dataset.kkReadyLabel : purchaseButton.dataset.kkUnavailableLabel; }
      variantInput.setAttribute('value', nextVariantId || '');
      variantInput.value = nextVariantId || '';
    }
  });
  initializePurchaseForms();

  document.addEventListener('submit', function(event) {
    const form = event.target.closest('.kk-product-form');
    if (!form) return;
    event.preventDefault();
    const pricing = form.closest('.kk-pricing');
    if (form.dataset.kkSubmitting === 'true' || (pricing && pricing.dataset.kkSubmitting === 'true')) return;
    const addonDialog = pricing && pricing.querySelector('[data-kk-addon-dialog]');
    if (addonDialog && form.dataset.kkAddonConfirmed !== 'true') {
      openAddonDialog(addonDialog, form);
      return;
    }
    form.dataset.kkAddonConfirmed = 'false';
    const scopeInput = form.querySelector('.kk-plan-scope input:checked');
    const variantInput = form.querySelector('input[name="id"][data-kk-variant-both]');
    if (!scopeInput || !variantInput) return;
    const scopeKey = scopeInput.value === 'GP1 + GP2' ? 'both' : scopeInput.value.toLowerCase();
    const nextVariantId = variantInput.dataset['kkVariant' + scopeKey.charAt(0).toUpperCase() + scopeKey.slice(1)];
    if (!nextVariantId || variantInput.dataset['kkAvailable' + scopeKey.charAt(0).toUpperCase() + scopeKey.slice(1)] !== 'true') return;
    variantInput.setAttribute('value', nextVariantId);
    variantInput.value = nextVariantId;
    const quantityInput = form.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.setAttribute('value', '1');
      quantityInput.value = '1';
    }
    const accessTierInput = form.querySelector('input[name="properties[_kk_access_tier]"]');
    if (accessTierInput) {
      accessTierInput.setAttribute('value', form.dataset.kkAccessTier || '');
      accessTierInput.value = form.dataset.kkAccessTier || '';
    }
    const circuitAccessInput = form.querySelector('input[name="properties[_kk_circuit_access]"]');
    if (circuitAccessInput) {
      circuitAccessInput.setAttribute('value', form.dataset.kkCircuitAccess || '');
      circuitAccessInput.value = form.dataset.kkCircuitAccess || '';
    }
    form.dataset.kkSubmitting = 'true';
    if (pricing) {
      pricing.dataset.kkSubmitting = 'true';
      pricing.querySelectorAll('[data-kk-purchase-scope], [data-kk-purchase-addons], .kk-plan-scope, .kk-product-form button[type="submit"]').forEach(function(control) { control.disabled = true; });
    }
    const submitButton = form.querySelector('button[type="submit"]');
    const originalButtonLabel = submitButton ? submitButton.textContent : '';
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = form.dataset.kkLoadingLabel;
    }
    const cartUrl = form.dataset.kkCartUrl;
    const cartJsonUrl = cartUrl + '.js';
    const cartUpdateUrl = form.dataset.kkCartUpdateUrl + '.js';
    const cartAddUrl = form.action + '.js';
    const productId = String(form.dataset.kkAccessProductId || '');
    const properties = {
      'Prüfungsbereich': scopeInput.value,
      '_kk_access_tier': form.dataset.kkAccessTier || '',
      '_kk_circuit_access': form.dataset.kkCircuitAccess || ''
    };
    const addonItems = Array.from(pricing ? pricing.querySelectorAll('[data-kk-purchase-addons] input[data-kk-addon]:checked') : []).map(function(input) {
      const moduleName = input.dataset.kkAddon;
      return {
        id: Number(input.value), quantity: 1,
        properties: {
          '_kk_purchase_for': 'self',
          '_kk_module': moduleName,
          'Zusatzmodul': moduleName === 'circuit' ? 'Kältekreislauf' : 'Störungssimulation'
        }
      };
    }).filter(function(item) { return Number.isSafeInteger(item.id) && item.id > 0; });
    fetch(cartJsonUrl, { headers: { 'Accept': 'application/json' } })
      .then(function(response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function(cart) {
        const updates = {};
        cart.items.forEach(function(item) {
          const otherRecipient = item.properties && (item.properties._kk_recipient_email || item.properties._kk_purchase_for === 'other');
          if (String(item.product_id) === productId && !otherRecipient) updates[item.key] = 0;
        });
        if (Object.keys(updates).length === 0) return null;
        return fetch(cartUpdateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function(response) {
          if (!response.ok) throw new Error('update');
          return response.json();
        });
      })
      .then(function() {
        return fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(nextVariantId), quantity: 1, properties: properties }].concat(addonItems).reverse() })
        });
      })
      .then(function(response) {
        if (!response.ok) throw new Error('add');
        window.location.assign(cartUrl);
      })
      .catch(function() {
        form.dataset.kkSubmitting = 'false';
        if (pricing) {
          pricing.dataset.kkSubmitting = 'false';
          pricing.querySelectorAll('[data-kk-purchase-scope], [data-kk-purchase-addons], .kk-plan-scope').forEach(function(control) { control.disabled = false; });
          initializePurchaseForms();
        }
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalButtonLabel;
        }
        window.alert(form.dataset.kkErrorLabel);
      });
  }, true);

  document.addEventListener('click', function(event) {
    const powerButton = event.target.closest('[data-kk-power]');
    if (!powerButton) return;
    const preview = powerButton.closest('[data-kk-circuit]');
    if (!preview) return;
    const running = powerButton.getAttribute('aria-checked') !== 'true';
    powerButton.setAttribute('aria-checked', running ? 'true' : 'false');
    preview.classList.toggle('is-running', running);
    const label = running ? powerButton.dataset.on : powerButton.dataset.off;
    const detail = running ? powerButton.dataset.onDetail : powerButton.dataset.offDetail;
    preview.querySelectorAll('[data-kk-power-state]').forEach(function(element) { element.textContent = label; });
    preview.querySelectorAll('[data-kk-preview-status]').forEach(function(element) { element.textContent = detail; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const kkCartShell = document.querySelector('[data-kk-cart-page]');
  if (kkCartShell) {
    const kkAccessLines = Array.from(kkCartShell.querySelectorAll('[data-kk-access-line-key]'));
    const kkUpdates = {};
    kkAccessLines.forEach(function(line) {
      if (Number(line.dataset.kkAccessLineQuantity) !== 1) {
        kkUpdates[line.dataset.kkAccessLineKey] = 1;
      }
    });
    if (Object.keys(kkUpdates).length > 0) {
      fetch(kkCartShell.dataset.kkCartUpdateUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: kkUpdates })
      }).then(function(response) {
        if (response.ok) window.location.reload();
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
